// extracted by css-extract-rspack-plugin
export default {"rating":"QU4bp","average_rating":"YzUS5","averageRating":"YzUS5","rating_text":"p71Y2","ratingText":"p71Y2","invisible":"UDPju","votes":"qF6k5"};